import { render, staticRenderFns } from "./SOAP.vue?vue&type=template&id=b0d546fa&"
import script from "./SOAP.vue?vue&type=script&lang=js&"
export * from "./SOAP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports